import { Component, HostBinding, inject, OnInit } from '@angular/core';
import { css } from '@emotion/css';
import { AuthService } from '../../services/auth/auth.service';
import { RegionSelectPage } from '../region-select/region-select.component';

@Component({
  template: `<app-regions></app-regions>`,
  imports: [RegionSelectPage],
})
export class LoginLandingPage implements OnInit {
  @HostBinding('class') className = css({ flexGrow: 1 });

  private auth = inject(AuthService);

  async ngOnInit() {
    await this.auth.handleRedirect();
  }
}
